import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FormControlRadio, RadioControl } from '../../../../create-request/models/form/FormControlRadio';
import { ActionCenterRedirectService } from '../../../services/ActionCenterRedirect.service';

@Component({
  standalone: false,
  selector: 'mm-radio-control',
  templateUrl: './radio-control.component.html',
  styleUrls: ['./radio-control.component.scss'],
})
export class RadioControlComponent implements OnInit {
  @Input() parentForm!: UntypedFormGroup;
  @Input() radioModel!: RadioControl;
  constructor(
    private actionCenterRedirectService: ActionCenterRedirectService
  ) {}

  ngOnInit(): void {}

  get hasError(): boolean {
    const control = this.parentForm?.controls[`${this.radioModel?.controlName}`];
    if (control?.disabled) {
      return (typeof control?.validator === 'function') && Object.keys(control.validator(control) ?? []).length > 0;
    }
    if (control?.touched) {
      return control?.invalid ?? false
    }
    return false;
  }

  get errorText(): string {
    return this.radioModel.validationMessage;
  }

  redirect(radio: FormControlRadio) {
    if (radio.warning?.link?.isActionCenterHyperLink) {
      this.actionCenterRedirectService.redirectToActionCenter();
    } else {
      window.open(radio.warning?.link?.url, radio.warning?.link?.target);
    }
  }
}

